import React, { useEffect, useState } from 'react';
import { Box, Container, Typography, IconButton, Collapse, Alert } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CloseIcon from '@mui/icons-material/Close';

function EventBanner({ open, handleClose }){
  // ✅ 배너 클릭 시, 판매 페이지로 이동합니다.
  const handleBannerClick = () => {
    // 실제 판매 페이지 경로로 수정하세요.
    window.location.href = 'https://ppi.g2b.go.kr:8914/sm/dm/sch/searchGoodsDetail.do?invGdsIdntNo=00027354';
  };

  return (
  <Collapse in={open}>
      <Alert
        icon={<InfoOutlinedIcon fontSize="inherit" />}
        severity="info" // 정보성 배너 스타일
        onClick={handleBannerClick} // ✅ Alert 전체에 클릭 핸들러 추가
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={handleClose}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        }
        sx={{ 
          borderRadius: 0, // 모서리를 직각으로
          position: 'sticky', // 화면 상단에 고정
          top: 0,
          cursor:'pointer',
          zIndex: (theme) => theme.zIndex.appBar + 1, // 다른 요소들 위에 오도록 z-index 설정
        }}
      >
        <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
          혁신장터를 통한 기관 판매 진행중! 지금 바로 확인해보세요.
        </Typography>
      </Alert>
    </Collapse>
  )
}

export default EventBanner;
